import React, { useState, useEffect, useRef } from 'react';
import ContentDescriptionInput from './ContentDescriptionInput';

const MetaContent = ({
  option,
  editing,
  entryContent,
  register,
  setDisableDrag,
}) => {
  const [scrollable, setScrollable] = useState(false);
  const divContent = useRef(null);
  useEffect(() => {
    let height = divContent.current?.scrollHeight;
    if (!height) return;
    let threshold = editing ? 400 : 108;
    if (scrollable && height < threshold) {
      setScrollable(false);
    } else if (!scrollable && height >= threshold) {
      setScrollable(true);
    }
  }, [editing, entryContent.length]);
  return (
    <>
      <hr />
      <div
        ref={divContent}
        className={`option-meta-contents ${editing ? 'active' : ''} ${scrollable ? 'scrollable' : ''}`}
        onMouseEnter={() => (!editing ? setDisableDrag(true) : null)}
        onMouseLeave={() => (!editing ? setDisableDrag(false) : null)}
      >
        {entryContent.map((ec, i) => (
          <div
            key={ec[0].id + '-' + option.id}
            className={'meta' + (editing ? ' val' : '')}
          >
            <strong>{ec[0].title}:</strong>
            {editing ? (
              <>
                <ContentDescriptionInput
                  ec={ec}
                  option={option}
                  register={register}
                />
              </>
            ) : (
              <span className='truncated'>{ec[1].description}</span>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default MetaContent;
